import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../modules/infra/i18n';
import RangeSelect from '../common/rangeSelect';
import { withMinIntervalIfNotProvided } from './hoc/withMinInterval';
import InputWithIndeterminate from './inputWithIndeterminate';
import SimpleCheckbox from './simpleCheckbox';

const NotAvailableSelect = props => (
  <select
    className="c-select c-select--small layout__item u-1/4 u-1/8-extralarge-and-up u-mv0 u-mr-"
    disabled
    data-automation-id={`${props.name}-not-available`}
    {...props}
  >
    <option>{t('admin:shops.add.not_available')}</option>
  </select>
);

const AdvanceBookingForm = ({ minInterval, canCustomerCancel }) => (
  <div>
    <div className="layout__item">
      <div className="c-label-new u-mb--">{t('admin:shops.add.days_client_book_advance')}</div>
      <div className="u-width-120">
        <InputWithIndeterminate
          className="c-input"
          type="number"
          placeholder={t('admin:shops.add.number_of_days_placeholder')}
          name="advanceBookDays"
          min="1"
          max="365"
          step="1"
          required
        />
      </div>
    </div>
    <div className="layout__item">
      <div className="c-label-new u-mb--">{t('admin:shops.add.mins_client_book_beforehand')}</div>
      <RangeSelect
        name="advanceBookMins.hours"
        className="c-select c-select--small layout__item u-1/4 u-1/8-extralarge-and-up u-mv0 u-mr-"
        valueSuffix={t('admin:shops.add.hours_suffix')}
        start={0}
        end={25}
        data-automation-id="advanceBookMins.hours"
      />
      <RangeSelect
        name="advanceBookMins.minutes"
        className="c-select c-select--small layout__item u-1/4 u-1/8-extralarge-and-up u-mv0"
        valueSuffix={t('admin:shops.add.mins_suffix')}
        start={0}
        end={60}
        increment={minInterval}
        data-automation-id="advanceBookMins.minutes"
      />
    </div>
    <div className="layout__item">
      <SimpleCheckbox
        name="canCustomerCancel"
        id="canCustomerCancel"
        label={t('admin:shops.add.customer_cancellations')}
        wrapperClass="layout__item"
      />
    </div>
    <div className="layout__item">
      <div className="c-label-new u-mb--">{t('admin:shops.add.mins_client_cancel_before')}</div>
      <NotAvailableSelect name="advanceCancelMins.hours" display-if={!canCustomerCancel} />
      <RangeSelect
        name="advanceCancelMins.hours"
        display-if={canCustomerCancel}
        className="c-select c-select--small layout__item u-1/4 u-1/8-extralarge-and-up u-mv0 u-mr-"
        valueSuffix={t('admin:shops.add.hours_suffix')}
        start={0}
        end={25}
        data-automation-id="advanceCancelMins.hours"
      />
      <NotAvailableSelect name="advanceCancelMins.minutes" display-if={!canCustomerCancel} />
      <RangeSelect
        name="advanceCancelMins.minutes"
        display-if={canCustomerCancel}
        className="c-select c-select--small layout__item u-1/4 u-1/8-extralarge-and-up u-mv0"
        start={0}
        end={60}
        valueSuffix={t('admin:shops.add.mins_suffix')}
        increment={minInterval}
        data-automation-id="advanceCancelMins.minutes"
      />
    </div>
  </div>
);

AdvanceBookingForm.propTypes = {
  minInterval: PropTypes.number.isRequired,
  canCustomerCancel: PropTypes.bool.isRequired,
};

export default withMinIntervalIfNotProvided(AdvanceBookingForm);
